module.exports = __webpack_public_path__ + "img/4.482717c4.jpg";